<template>
  <div class="flex flex-col gap-6">
    <div>
      <p class="text-primary mb-2">OTP Input</p>
  
      <AccessTokenInput
        v-model="otpInput"
        @on-change="value => console.log('changed: ', value)"
        @on-complete="value => console.log('completed: ', value)"
      />
    </div>
    
    <ActionCard class="bg-quaternary text-dark" :icon="IconQrcode" text="Ler QR Code da OP" />

    <div class="flex flex-col gap-5">
      <p class="text-primary">Enabled Buttons</p>
      <VButton type="outline" title="Outline" :callback="handleClick" />

      <VButton type="solid" title="Solid" :callback="handleClick" />

      <div class="flex">
        <VButton type="chip" title="Chip" :callback="handleClick" />
      </div>
    </div>

    <div class="flex flex-col gap-5">
      <p class="text-primary">Disabled Buttons</p>
      <VButton type="outline" title="Outline" disabled :callback="handleClick" />

      <VButton type="solid" title="Solid" disabled :callback="handleClick" />

      <div class="flex">
        <VButton type="chip" title="Chip" disabled :callback="handleClick" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AccessTokenInput from '@/components/AccessTokenInput/AccessTokenInput.vue';
import VButton from '@/components/Button/VButton.vue';
import { showDefaultToast } from '@/helpers/toast-models';
import ActionCard from '@components/ActionCard/ActionCard.vue';
import { IconQrcode } from '@tabler/icons-vue';
import { onMounted, ref } from 'vue';

const otpInput = ref("");

onMounted(() => {
  showDefaultToast("Essa etiqueta de transporte é agrupada. Para iniciar a verificação, clique no botão \"Iniciar verificação\" referente à nota fiscal.", "error", 100000000);
  showDefaultToast("Teste", "success", 100000000);
})

async function handleClick() {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Async action completed')
      resolve(true)
    }, 2000)
  })
}
</script>
